import { useNewSidebarExperience } from "featureFlags/hooks/useNewSidebarExperience";
import { useLoginId } from "hooks/useLoginId";
import { useOrganization } from "hooks/useOrganization";

import { Editor } from "pages/DevelopWorkspace/Editor/Editor";
import ActiveEditorViewContextProvider from "pages/DevelopWorkspace/contexts/ActiveEditorViewContext/ActiveEditorViewContext";
import { DocumentsContextProvider } from "pages/DevelopWorkspace/contexts/DocumentsContext/DocumentsContext";
import { SQLynxLoader } from "pages/DevelopWorkspace/contexts/SQLynxContext/SQLynxLoader";
import { ScriptsContextProvider } from "pages/DevelopWorkspace/contexts/ScriptsContext/ScriptsContext";
import { ShortcutsOverlayProvider } from "pages/DevelopWorkspace/contexts/ShortcutsOverlayContext/ShortcutsOverlayContext";

import { useCurrentAccount } from "components/Account/useCurrentAccount";
import LeftSidebar from "components/LeftSidebar/LeftSidebar";
import LeftSidebarV2 from "components/LeftSidebarV2/LeftSidebarV2";

import { CopilotProvider } from "./Editor/Copilot/CopilotProvider";

import styles from "./styles.module.scss";

export const Workspace = () => {
  const { getAccount } = useCurrentAccount();
  const { loginId } = useLoginId();
  const { data: organization } = useOrganization();
  const newSidebarExperience = useNewSidebarExperience();

  const account = getAccount();

  if (!account || !loginId || !organization) {
    return null;
  }

  return (
    <ScriptsContextProvider>
      <DocumentsContextProvider
        account={account}
        loginId={loginId}
        organizationName={organization.organizationName}
      >
        <ActiveEditorViewContextProvider>
          <ShortcutsOverlayProvider>
            <div className={styles.wrapper}>
              <div className={styles.container}>
                {newSidebarExperience ? <LeftSidebarV2 /> : <LeftSidebar />}
                <div className={styles.content}>
                  <SQLynxLoader>
                    <CopilotProvider>
                      <Editor />
                    </CopilotProvider>
                  </SQLynxLoader>
                </div>
              </div>
            </div>
          </ShortcutsOverlayProvider>
        </ActiveEditorViewContextProvider>
      </DocumentsContextProvider>
    </ScriptsContextProvider>
  );
};
